<template>
    <section class="section df">
        <article class="article">
            <div class="content-box">
                <div class="content-header df">
                    <div>上传时间：{{$time(activity.addtime)}}</div>
                    <div>
                        <span class="header-info">收藏：{{activity.collects}}</span>
                        <span class="header-info">喜欢：{{activity.likes}}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="title">{{activity.title}}</div>
                    <div class="media-box">
                        <div v-for="v in activity.media" :key="v.id" class="media">
                            <img v-if="!v.src" :src="v.thumb" class="img" alt="">
                            <base-player v-if="v.src" :options="options(v)"></base-player>
                        </div>

                    </div>
                </div>
            </div>
            <div class="comment-box">
                <div v-show="comment_loading" class="loading-box">
                    <i class="loading"></i>
                    正在加载中，请稍候...
                </div>
                <div v-show="comment_loading_error" @click="loadComment" class="loading-box cp">
                    <span class="error-text">请求超时,</span>
                    <span class="dc"> 点击重新载入</span>
                </div>
                <div v-show="!comment_loading && !comment_loading_error">
                    <div class="comment-header">
                        <div @click="orderChange(0)" :class="order_hot ? 'comment-title-box' : 'active'">
                            <div class="comment-title" v-waves>全部评论</div>
                        </div>
                        <div v-if="activity.comments" @click="orderChange(1)" :class="order_hot ? 'active' : 'comment-title-box'">
                            <div class="comment-title" v-waves>按热度排序</div>
                        </div>
                    </div>
                    <div class="comment-send">
                        <img class="comment-avatar" :src="user.avatar" :alt="user.avatar">
                        <div class="comment-area-box">
                            <base-area :show="true" @send="sendComment" v-model="content"></base-area>
                        </div>
                    </div>

                    <div v-if="comments.length">
                        <div v-for="v in comments" :key="v.id" :class="`comment-list${v.rcount ? ' no-border' : ''}`">
                            <img class="comment-avatar" :src="v.thumb" alt="">
                            <div class="comment-main">
                                <div>
                                    <span class="comment-nickname">{{v.nico}}</span>
                                    <p class="comment-content">{{v.content}}</p>
                                    <div class="comment-tool">
                                        <span class="comment-tool-action">{{$time(v.addtime)}}</span>
                                        <span @click="likeComment(v, true)" :class="`comment-tool-action action-hover${v.is_like ? ' action-active' : ''}`">
                                                <i :class="`icon-zan${v.is_like ? '-fill' : ''}`"></i> {{v.likes || ''}}
                                            </span>
                                        <span class="comment-tool-action action-hover" @click="showEditor(v)">回复</span>
                                    </div>
                                </div>
                                <div v-show="v.area" class="comment-area-box">
                                    <base-area :show="v.area" @send="replyTop(v)" v-model="v.comment"></base-area>
                                </div>
                                <div v-if="v.replies.length" class="reply-box">
                                    <div class="comment-list" v-for="w in v.replies" :key="w.id">
                                        <div class="reply-main">
                                            <div class="reply-content-box">
                                                <span class="comment-nickname">{{w.nico}}</span>
                                                <div>
                                                    <span v-if="!w.is_direct" >
                                                        ：回复<span class="user-name"> @{{w.pnico}}</span>
                                                    </span>：{{w.content}}
                                                </div>
                                            </div>
                                            <div class="comment-tool">
                                                <span class="comment-tool-action">{{$time(w.addtime)}}</span>
                                                <span @click="likeComment(w)" :class="`comment-tool-action action-hover${w.is_like ? ' action-active' : ''}`">
                                                        <i :class="`icon-zan${w.is_like ? '-fill' : ''}`"></i> {{w.likes || ''}}
                                                    </span>
                                                <span @click="showEditor(w)" class="comment-tool-action action-hover">回复</span>
                                            </div>
                                            <div v-show="w.area" class="comment-area-box">
                                                <base-area :placeholder="`回复 @${w.nico}：`" :show="w.area" @send="sendReply(v, w)" v-model="w.comment"></base-area>
                                            </div>
                                        </div>
                                    </div>
                                    <span v-if="v.rcount > 2 && !v.showPage" @click="moreReplies(v)" class="comment-link">共{{v.rcount}}条评论</span>
                                    <el-pagination v-if="v.rcount > 10 && v.showPage" background layout="total, prev, pager, next" @current-change="page => replyChange(page, v)" :page-size="10" :total="v.rcount" class="replyPage"></el-pagination>

                                </div>
                            </div>
                        </div>
                        <el-pagination v-if="activity.comments > 20" background layout="total, prev, pager, next" :current-page="page" @current-change="commentChange" :page-size="20" :total="activity.comments" class="commentPage"></el-pagination>
                    </div>
                </div>
            </div>
        </article>
        <aside class="aside">
            <div class="pf">
                <div class="dancer-info pr">
                    <a :href="`/dancer/${activity.dancer_id}`" :style="`background-image: url('${activity.dancer_avatar}');`" class="dancer-avatar pa loading-bg" target="_blank"></a>
                    <a :href="`/dancer/${activity.dancer_id}`" class="dancer-name" target="_blank">{{activity.dancer_name}}</a>
                    <div class="dancer-media df">
                        <a class="dancer-media-link" :href="`/dancer/${activity.dancer_id}`" target="_blank">视频 {{activity.dancer_videos}}</a>
                        <span class="divider dib"></span>
                        <a class="dancer-media-link" :href="`/dancer/${activity.dancer_id}/activity`" target="_blank">动态 {{activity.dancer_activities}}</a>
                    </div>
                    <div v-show="!activity.dancer_follow" @click="follow" class="btn-follow bg">关注</div>
                    <div v-show="activity.dancer_follow" @click="unFollow" class="btn-follow unfollow">取消关注</div>
                </div>
                <div class="activity-toolbar-box df cp">
                    <div @click="like" class="activity-toolbar activity-zan-box">
                        <div class="activity-zan">
                            <i :class="`${activity.is_like ? 'icon-zan-fill active' : 'icon-zan'}`"></i>{{activity.likes}}
                        </div>
                        <div class="activity-toolbar-text">{{activity.is_like ? '已' : ''}}点赞</div>
                    </div>
                    <div @click="collect" class="activity-toolbar activity-collect-box">
                        <i :class="`${activity.is_collect ? 'icon-collected active' : 'icon-collect'}`"></i>
                        <div class="activity-toolbar-text">{{activity.is_collect ? '已' : ''}}收藏</div>
                    </div>
                    <div class="activity-toolbar">
                        <i class="icon-share-flat"></i>
                        <div class="activity-toolbar-text">分享</div>
                    </div>
                </div>
            </div>
        </aside>
    </section>
</template>

<script>
    export default {
        data: () => ({
            content: '',
            comment_loading: false,
            comment_loading_error: false,
            comment_sending: false,
            comment_changing: false,
            comments: [],
            is_liking: false,
            is_collecting: false,
            is_following: false,
            order_hot: 0,
            page: 1,
            activity: {
                dancer_id: 1,
                dancer_name: 'Hoan',
                dancer_avatar: '',
                dancer_videos: 50,
                dancer_activities: 66,
                dancer_follow: false,
                title: '',
                addtime: '',
                likes: 0,
                comments: 0,
                is_collect: true,
                is_like: false,
                media: [],
            },
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
            query() {
                return this.$route.query;
            },
            state() {
                return this.$store.state;
            },
            user() {
                return this.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.state.sign;
            },
        },
        watch: {
            uid() {
                this.api.get(`dancers/${this.id}/follow`).then(e => {
                    this.is_follow = !!e;
                }, () => {});
            },
            order_hot() {
                this.commentChange(this.page);
            }
        },
        methods: {
            options: (v) => ({
                sources: [{
                    type: 'video/mp4',
                    src: v.src //url地址
                }],
                poster: v.thumb, //你的封面地址
                fluid: false,
                width: v.width,
            }),
            loadComment() {// 加载评论数据
                if (this.comment_loading) return;
                this.comment_loading = true;
                this.comment_loading_error = false;

                this.api.get(`dancers/activities/${this.id}/comments`).then(e => {
                    this.comment_loading = this.comment_loading_error = false;
                    this.comments = e;
                }, e => {
                    this.alert.err(e.message);
                    this.comment_loading = false;
                    this.comment_loading_error = true;
                });
            },
            orderChange(order_hot) {
                this.order_hot = order_hot;
                this.page = 1;
            },
            async commentChange(page) {// 评论页码改变
                if (this.comment_changing) return;
                this.page = page;
                this.comment_changing = true;

                const {order_hot} = this;
                this.comments = await this.api.get(`dancers/activities/${this.id}/comments`, {page, order_hot}).catch(e => this.alert.err(e.message));
                this.comment_changing = false;
            },
            async replyChange(page, v) {// 回复页码改变
                if (v.reply_changing) return;
                v.reply_changing = true;

                v.replies = await this.api.get(`dancers/activities/comments/${v.id}`, {page}).catch(e => this.alert.err(e.message));
                v.reply_changing = false;
            },
            moreReplies(v) {// 更多回复
                if (v.comment_loading) return;
                v.comment_loading = true;

                this.api.get(`dancers/activities/comments/${v.id}`).then(e => {
                    v.replies = e;
                    this.$set(v, 'showPage', true);
                    v.comment_loading = false;
                }, e => {
                    this.alert.err(e.message);
                    v.comment_loading = false;
                });
            },
            showEditor(v) {
                this.$set(v, 'area', !v.area);
            },
            async follow() {
                if (this.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                const {activity} = this;
                activity.dancer_follow = this.is_following = true;

                await this.api.post(`dancers/${activity.dancer_id}/follow`).catch(e => {
                    activity.dancer_follow = false;
                    this.alert.err(e.message);
                });
                this.is_following = false;
            },
            unFollow() {
                if (this.is_following) return;

                this.confirm({
                    title: '取消关注',
                    content: `确认要取消关注该舞者吗?`,
                    sureCb: async () => {
                        this.is_following = true;

                        const {activity} = this;
                        activity.dancer_follow = false;

                        await this.api.del(`dancers/${activity.dancer_id}/follow`).catch(e => {
                            activity.dancer_follow = true;
                            this.alert.err(e.message);
                        });
                        this.is_following = false;
                    }
                });
            },
            async like() {
                if (this.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.is_liking = true;

                const {activity} = this;

                if (activity.is_like) {// 点赞
                    activity.likes--;
                    activity.is_like = false;
                    await this.api.del(`dancers/activities/${this.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        activity.likes++;
                        activity.is_like = true;
                    });
                } else {// 取消点赞
                    activity.likes++;
                    activity.is_like = true;
                    await this.api.post(`dancers/activities/${this.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        activity.likes--;
                        activity.is_like = false;
                    });
                }

                this.is_liking = false;
            },
            async collect() {
                if (this.is_collecting) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.is_collecting = true;
                const {activity} = this;

                if (activity.is_collect) {// 点赞
                    activity.is_collect = false;
                    await this.api.del(`dancers/activities/${this.id}/collects`).catch(e => {
                        this.alert.err(e.message);
                        activity.is_collect = true;
                    });
                } else {// 取消点赞
                    activity.is_collect = true;
                    await this.api.post(`dancers/activities/${this.id}/collects`).catch(e => {
                        this.alert.err(e.message);
                        activity.is_collect = false;
                    });
                }

                this.is_collecting = false;
            },
            sendComment() {
                const {content, id} = this;

                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (this.comment_sending) return;
                this.comment_sending = true;

                this.api.post(`dancers/activities/${id}/comments`, {content}).then(e => {
                    this.comments.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        rcount: 0,
                        replies: []
                    });

                    this.content = this.comment_sending = '';
                    this.activity.comments++;
                }, e => {
                    this.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            replyTop(v) {
                const content = v.comment, is_direct = 1, pid = v.user_id;
                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (v.comment_sending) return;
                this.$set(v, 'comment_sending', true);

                this.api.post(`dancers/activities/${v.id}/replies`, {content, is_direct, tid: v.id, pid}).then(e => {
                    v.replies.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        is_direct,
                    });
                    v.comment_sending = v.area = false;// 子组件接受boolean
                    v.comment = '';
                    v.rcount++;
                    v.comments++;
                }, e => {
                    v.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            sendReply(comment, reply) {
                const content = reply.comment, pid = comment.user_id;
                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (reply.comment_sending) return;
                this.$set(reply, 'comment_sending', true);

                this.api.post(`dancers/activities/${this.id}/replies`, {content, tid: comment.id, pid, p_content_id: reply.id}).then(e => {
                    comment.replies.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        pid,
                        pnico: reply.nico,
                    });
                    reply.comment_sending = reply.area = false;
                    reply.comment = '';
                    comment.rcount++;
                    this.activity.comments++;
                }, e => {
                    reply.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            async likeComment(v, isTop = false) {
                if (v.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_liking = true;
                const comment = isTop ? 'comments' : 'replies';

                if (v.is_like) {// 点赞
                    v.likes--;
                    v.is_like = false;
                    await this.api.del(`dancers/activities/${comment}/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.likes++;
                        v.is_like = true;
                    });
                } else {// 取消点赞
                    v.likes++;
                    v.is_like = true;
                    await this.api.post(`dancers/activities/${comment}/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = false;
                    });
                }

                v.is_liking = false;
            },
        },
        beforeMount() {
            this.api.get(`dancers/activities/${this.id}`).then(e => {
                this.activity = e;
            });
            this.loadComment();
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/comment.css";
    @import "../../../static/css/views/dancer/activity-detail.css";
</style>



// WEBPACK FOOTER //
// src/views/dancer/ActivityDetail.vue